import { colors } from "@mosanic/styles";
import {default as s } from "./Progress.styles";

export const Progress = ({color = colors.util.primary.base, track = colors.util.gray.lighter, value = 0, height= 8, ...other}) => (
    <s.Track track={track} height={height} {...other}>
        <s.Progress color={color} value={value}/>
    </s.Track>
)
